// Original mascots, drawn in the round-and-simple idiom: circles, dot eyes,
// almost no facial detail, one flat pastel each. Not copies of anyone else's
// characters — the style is borrowed, the drawings are ours.

const svg = (body) =>
  `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">${body}</svg>`;

/** A small round monkey. Header mascot. */
export const monkey = svg(`
  <circle cx="17" cy="46" r="14" fill="#e8b596"/>
  <circle cx="17" cy="46" r="8"  fill="#ffd9c4"/>
  <circle cx="83" cy="46" r="14" fill="#e8b596"/>
  <circle cx="83" cy="46" r="8"  fill="#ffd9c4"/>
  <circle cx="50" cy="50" r="34" fill="#e8b596"/>
  <ellipse cx="50" cy="60" rx="25" ry="19" fill="#fff0e4"/>
  <ellipse cx="28" cy="57" rx="6" ry="4" fill="#ffb3c4" opacity=".55"/>
  <ellipse cx="72" cy="57" rx="6" ry="4" fill="#ffb3c4" opacity=".55"/>
  <circle cx="39" cy="43" r="4.2" fill="#4a3f4a"/>
  <circle cx="61" cy="43" r="4.2" fill="#4a3f4a"/>
  <circle cx="40.4" cy="41.6" r="1.4" fill="#fff"/>
  <circle cx="62.4" cy="41.6" r="1.4" fill="#fff"/>
  <path d="M43 60 q7 6 14 0" stroke="#4a3f4a" stroke-width="2.6"
        stroke-linecap="round" fill="none"/>
`);

/** A small round bunny, for the moment it works. */
export const bunny = svg(`
  <ellipse cx="36" cy="20" rx="9"  ry="19" fill="#ffe1ea"/>
  <ellipse cx="36" cy="21" rx="4.5" ry="13" fill="#ffb8cd"/>
  <ellipse cx="64" cy="20" rx="9"  ry="19" fill="#ffe1ea"/>
  <ellipse cx="64" cy="21" rx="4.5" ry="13" fill="#ffb8cd"/>
  <circle cx="50" cy="58" r="31" fill="#ffe1ea"/>
  <ellipse cx="30" cy="64" rx="6" ry="4" fill="#ff9db8" opacity=".6"/>
  <ellipse cx="70" cy="64" rx="6" ry="4" fill="#ff9db8" opacity=".6"/>
  <circle cx="40" cy="54" r="4" fill="#4a3f4a"/>
  <circle cx="60" cy="54" r="4" fill="#4a3f4a"/>
  <circle cx="41.3" cy="52.7" r="1.3" fill="#fff"/>
  <circle cx="61.3" cy="52.7" r="1.3" fill="#fff"/>
  <path d="M44 66 q6 5 12 0" stroke="#4a3f4a" stroke-width="2.4"
        stroke-linecap="round" fill="none"/>
`);

/** A sleepy one, for when something did not work out. */
export const sleepy = svg(`
  <circle cx="18" cy="47" r="13" fill="#cfe0f5"/>
  <circle cx="82" cy="47" r="13" fill="#cfe0f5"/>
  <circle cx="50" cy="52" r="33" fill="#dbe9fa"/>
  <ellipse cx="50" cy="61" rx="24" ry="17" fill="#f2f8ff"/>
  <path d="M33 45 q6 5 12 0"  stroke="#4a3f4a" stroke-width="2.6" stroke-linecap="round" fill="none"/>
  <path d="M55 45 q6 5 12 0"  stroke="#4a3f4a" stroke-width="2.6" stroke-linecap="round" fill="none"/>
  <ellipse cx="50" cy="63" rx="3.5" ry="2.6" fill="#4a3f4a"/>
`);

/** Inject an SVG string as a real element. */
export function mascotNode(source, className = 'mascot') {
  const wrapper = document.createElement('div');
  wrapper.innerHTML = source;
  const node = wrapper.firstElementChild;
  node.setAttribute('class', className);
  return node;
}
